export function sanitizePickableIds<T extends string>(
  stored: unknown,
  all: readonly T[],
  newlyAdded: readonly T[] = [],
): T[] {
  const allowed = new Set(all);
  if (!Array.isArray(stored)) return [...all];
  const selected = stored.filter(
    (id): id is T => typeof id === "string" && allowed.has(id as T),
  );
  if (stored.length === 0) return [];
  if (selected.length === 0) return [...all];
  const selectedSet = new Set(selected);
  const extra = newlyAdded.filter((id) => allowed.has(id) && !selectedSet.has(id));
  return extra.length > 0 ? [...selected, ...extra] : selected;
}

export const ZERO_OVERVIEW_STATS_KEY = "zeroOverviewSelectedStats";
export const ZERO_MONTHLY_EXTRAS_KEY = "zeroMonthlySelectedExtras";
export const ZERO_OVERVIEW_EXTRAS_KEY = "zeroOverviewSelectedExtras";
